import React from "react";
import PropTypes from "prop-types";
import { ConnectedRouter } from "connected-react-router";
import { Route, Switch } from "react-router";
import { useDispatch, useSelector } from "react-redux";

// actions
import { showToasterMessage } from "@/store/actions/commonActions";

// utils
import routePaths from "@/utils/route-paths";

// components
import MenuBar from "@/components/shared/menu-bar";
import Dashboard from "@/components/modules/Dashboard";
import InternalFairStudents from "@/components/modules/InternalFairStudents";
import Login from "@/components/modules/Login";
import NotFoundPage from "@/components/modules/Error";
import Loader from "@/components/shared/loader";
import Alert from "@/components/shared/Alert";
import Redirection from "@/components/modules/Redirection";

// material
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

// props
import { menuBarProps } from "@/props-constants/menubar-props";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));
let Router = function ({ history }) {
	const classes = useStyles();
	const dispatch = useDispatch();
	const commonToast = useSelector((state) => state.common);
	return (
		<Box className={classes.root}>
			{commonToast && commonToast.toaster && commonToast.toaster.message && (
				<Alert
					autoHideDuration={4000}
					onCloseCallback={() => {
						dispatch(showToasterMessage(null));
					}}
					title={
						commonToast.toaster.message.message || commonToast.toaster.message
					}
					severity={commonToast.toaster.toasterColor}
				/>
			)}
			<Box id="header" className={classes.header}>
				<MenuBar logo={menuBarProps.logo} />
			</Box>
			<Grid container id="body" className={classes.body}>
				<Grid item xs={12} md={12} className={classes.dataContainer}>
					{commonToast.isLoading ? (
						<Box height="100vh" width="100vw">
							<Loader />
						</Box>
					) : (
						<ConnectedRouter history={history}>
							<Switch>
								<Route
									exact
									path={routePaths.DASHBOARD}
									render={() => <Dashboard />}
								/>
								<Route
									exact
									path={routePaths.INTERNAL_FAIR_STUDENTS}
									render={() => <InternalFairStudents />}
								/>
								<Route
									exact
									path={routePaths.UNIVERSITY_LOGIN}
									render={() => <Login />}
								/>
								<Route
									exact
									path={routePaths.REDIRECTION}
									render={() => <Redirection />}
								/>
								<Route
									exact
									path={routePaths.NOT_FOUND}
									render={() => <NotFoundPage />}
								/>
								<Route render={() => <NotFoundPage />} />
							</Switch>
						</ConnectedRouter>
					)}
				</Grid>
			</Grid>
		</Box>
	);
};

Router.propTypes = {
	history: PropTypes.object.isRequired,
};

export default Router;
